// extracted by mini-css-extract-plugin
export default {"root":"z9o1q","item":"Iz5yQ","itemTitle":"CVxHU","itemInner":"CSRzP","commonProperties":"YMJrH"};